import type { Dispatch, SetStateAction } from 'react'
import React, { createContext, useContext, useState } from 'react'

type TerminalContext = {
  selectedTerminals: string[]
  setSelectedTerminals: Dispatch<SetStateAction<string[]>>
}

export const SelectedTerminalContext = createContext<TerminalContext>({
  selectedTerminals: [],
  setSelectedTerminals: () => [],
})

export function SelectedTerminalProvider({ children }) {
  const [selectedTerminals, setSelectedTerminals] = useState<string[]>([])

  return (
    <SelectedTerminalContext.Provider value={{ selectedTerminals, setSelectedTerminals }}>
      {children}
    </SelectedTerminalContext.Provider>
  )
}
export const useSelectedTerminalContext = () => {
  const context = useContext(SelectedTerminalContext)
  if (!context) {
    throw new Error('Card Management Context must be used within Card Management')
  }
  return context
}
